export default __webpack_public_path__ + "static/screenSecondSectionEnBig-73ad454e465470d5b9bf4c44c2098d33.webp";